var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 93,
    viewBox: "0 0 92 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 91,
    height: 91,
    rx: 45.5,
    fill: "url(#paint0_linear_899_6496)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 91,
    height: 91,
    rx: 45.5,
    stroke: "url(#paint1_linear_899_6496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_6496",
    x1: 0,
    y1: 46.5,
    x2: 92,
    y2: 46.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_6496",
    x1: 46,
    y1: 0.5,
    x2: 46,
    y2: 92.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeBackground);
export default __webpack_public_path__ + "static/media/prize-background.79be520139a2537984b28ca7cb28a3ff.svg";
export { ForwardRef as ReactComponent };